var $popupOverlay;

jQuery(document).ready(function ($) {
    var $suggestCorrections = $('#suggest-corrections');
    var $correctionsContainer = $('#corrections_container');
    $popupOverlay = $('.popup-overlay').eq(0);
    $.ajax({
        url: 'https://' + window.location.host + '/api/fe/get-corrections-popup/',
        type: 'GET',
        data: {postid: $suggestCorrections.data('post-id'), postorigin: $suggestCorrections.data('postOrigin')},
        success: function (html) {
            $correctionsContainer.html(html).promise().done(function(){
                $suggestCorrections.click(function (e) {
                    var popupContainer;

                    $('html').addClass('overlay');
                    popupContainer = $(this).attr('data-popup-target');

                    $popupOverlay.empty().append($(popupContainer).html());
                    $popupOverlay.css('display', 'block');
                    e.preventDefault();
                });
            });
        }
    });
});

function submitForm($container) {
    var your_name = $.trim($container.find('#corrections_name').val());
    var your_email = $.trim($container.find('#corrections_email').val());
    var message = $.trim($container.find('#corrections_message').val());

    var highlightLabel = function($el) {
        $container.find('[for="' + $el.attr('id') + '"]').addClass('error');
    };

    var resetLabel = function($el) {
        $container.find('[for="' + $el.attr('id') + '"]').removeClass('error');
    };

    var sendCorrections = function(correctionData) {
        var $overlay = $container;

        $.ajax({
            type: 'POST',
            url: 'https://' + window.location.host + '/api/fe/correction',
            data: correctionData,
            dataType: 'json',
            success: function(data) {
                var parsedData;
                var $content = $overlay.find('.popup-content').eq(0);

                try {
                    parsedData = JSON.parse(data);

                    $content.animate({
                        opacity: 'toggle'
                    }, {
                        duration: 'fast',
                        specialEasing: {
                            width: 'linear'
                        },
                        complete: function() {
                            $content.empty();
                            $content.html($('<div/>').html(parsedData.message).text());
                            $content.animate({ opacity: 'toggle' }, { duration: 'slow', specialEasing: { width: 'linear' } });
                        }
                    });
                } catch (e) {
                    console.log('Error parsing response');
                }
            }
        });
    };

    var webglEnabled = function() {
        try {
            var canvas = document.createElement('canvas');
            return !!window.WebGLRenderingContext &&
                (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));
        } catch (e) {
            return false;
        }
    };

    var flashEnabled = function() {
        try {
            return (typeof navigator.plugins == "undefined" || navigator.plugins.length === 0) ? !!(new ActiveXObject("ShockwaveFlash.ShockwaveFlash")) : navigator.plugins["Shockwave Flash"];
        } catch (e) {
            return false;
        }
    };

    var metadata = function() {
        try {
            var navigatorObject = window.navigator;
            return {
                platform: navigatorObject.platform,
                os: navigatorObject.oscpu,
                userAgent: navigatorObject.userAgent,
                jsEnabled: true,
                cookieEnabled: navigatorObject.cookieEnabled ? 'true' : 'false',
                websocketSupported: 'WebSocket' in window && window.WebSocket.CLOSING === 2 ? 'true' : 'false',
                webglSupported: webglEnabled() ? 'true' : 'false',
                flashSupported: flashEnabled() ? 'true' : 'false',
                language: navigatorObject.language,
                browserSize: $(window).height() + ' x ' + $(window).width(),
                screenSize: window.screen.height + ' x ' + window.screen.width,
                colorDepth: window.screen.colorDepth
            };
        } catch (e) {
            return {};
        }
    };

    resetLabel($container.find('#corrections_name'));
    resetLabel($container.find('#corrections_email'));
    resetLabel($container.find('#corrections_message'));

    try {
        var incomplete = false;

        if (your_name === "") {
            highlightLabel($container.find('#corrections_name'));
            incomplete = true;
        }

        if (your_email === "") {
            highlightLabel($container.find('#corrections_email'));
            incomplete = true;
        }

        if (message === "") {
            highlightLabel($container.find('#corrections_message'));
            incomplete = true;
        }

        if (incomplete) {
            throw "Please fill out all the required fields.";
        } else {
            $container.find('#corrections_error').empty();
            sendCorrections({
                name: $container.find('#corrections_name').val(),
                email: $container.find('#corrections_email').val(),
                correction: $container.find('#corrections_message').val(),
                csrf: $container.find('#csrf').val(),
                postOrigin: $('#suggest-corrections').attr('data-post-origin'),
                postID: $('#suggest-corrections').attr('data-post-id'),
                edition: $('#suggest-corrections').attr('data-edition'),
                metadata: metadata()
            });
        }
    } catch (e) {
        $container.find('#corrections_error').html(e);
    }
}

function clearPopup() {
    $('html').removeClass('overlay');
    $popupOverlay.css('display', 'none');
    $popupOverlay.empty();
}